import React, { FC } from 'react';
import styled from '@emotion/styled';
import { IFullSearchResult, ISanitizedFilterOutput } from '$models';
import { ProductGrid } from './product-grid';
import { FacetControls } from './facet-controls';
import { useProductResult } from '../hooks/single-search';
import { FacetList } from '../helpers';
import { SearchContentTypes } from '~/modules/search';

type Props = {
    facetInitData?: IFullSearchResult;
    productResult: ISanitizedFilterOutput[] | undefined;
    onLoadNextPage: () => void;
    onSelectedFacets: (facet: FacetList) => void;
    loadingPage?: boolean;
    filterId?: string;
    pId?: string;
    pageId?: string;
    sId?: string;
};

export const ProductList: FC<Props> = ({
    facetInitData,
    productResult,
    onLoadNextPage,
    loadingPage,
    onSelectedFacets,
    filterId,
    pId,
    pageId,
    sId,
}: Props) => {
    const {
        products,
        total,
        facetSelection,
        facets,
        sortingOptions,
        searchTerm: resultSearchTerm,
    } = useProductResult(productResult);

    return (
        <FilterModuleContainer>
            <FacetControls
                initialData={facetInitData}
                onConfirm={onSelectedFacets}
                filterId={filterId}
                pId={pId}
                pageId={pageId}
                sId={sId}
                totalResults={total}
                facets={facets}
                searchTerm={resultSearchTerm}
                selectedFacets={facetSelection}
                sortingOptions={sortingOptions}
                searchMode={SearchContentTypes.Products}
            />
            <ProductGrid
                products={products}
                totalResults={total}
                onLoadMore={onLoadNextPage}
                loadingPage={loadingPage}
            />
        </FilterModuleContainer>
    );
};

const FilterModuleContainer = styled.div({});
